document.addEventListener('DOMContentLoaded', function() {
  const announcement = document.querySelector('.announcement');
  if (!announcement) return;

  const announcementId = announcement.dataset.announcementId;
  const cookieName = `announcement_dismissed_${announcementId}`;

  // Helper: get cookie by name
  const getCookie = name => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  // Start hidden until we decide to show
  announcement.style.display = 'none';

  // Only show if cookie NOT set
  if (!getCookie(cookieName)) {
    announcement.style.display = 'block';
  }

  // Handle close click
  const closeBtn = announcement.querySelector('.announcement-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      announcement.style.display = 'none';
      const oneWeek = 60 * 60 * 24 * 7;
      const domain = window.location.hostname.replace(/^www\./, ''); // shared across subdomains
      document.cookie = `${cookieName}=true; path=/; domain=.${domain}; max-age=${oneWeek}; Secure; SameSite=Lax`;
    });
  }
});